var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement } from "@max/max";
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import { RewardType } from '@/types/teamRanking';
import ScrollView from '@hfe/max-scrollview';
import { API_PATH, RequestStatus, useRequest } from '@/hooks/useRequest';
import LImage from '@max/leez-image';
import ModalBaseContainer from '@max/leez-modal-base-container';
import TopView from '@max/leez-top-view';
import { useEffect, useMemo, useRef, useState } from 'react';
import Button from '@hfe/max-button';
import LinearGradient from '@hfe/max-linear-gradient';
import { convertCentsToYuan, isH5URL, lessThan, MTfinStyle, convertCentsToYuanInteger } from '@/utils/common';
import { NO_VALID_ORDER_FOR_FREE_CARD } from '@/types/shared';
import { useMonitorEngineContext, useMonitorJumper } from '@nibfe/mcp-monitor-sdk';
import FreeCardDrawResultPopup from '@/components/free-card';
import LoadingView from '@max/leez-loading-view';
import './index.scss';
import { getFullScreenSize } from '@/utils/layout';
import UnlockedFreeCardPopup from '../unlocked-free-card-popup';
import { useOrderPopup } from '@/hooks/useOrderPopup';
import { POPUP_ORDER } from '@/const';
import ActivityInvalid from '../activity-invalid';
import { getPlatformType, isWeixinMiniProgramOrWeixinWebview, PlatformType } from '@nibfe/mkt-env-api';
import { convertH5ToWebviewPath } from '@nibfe/mkt-navigate-api';
import { navigateTo } from '@max/meituan-uni-navigate';
import Sensor from '@max/mbc-sensor';
import { RewardRecordsTheme } from '@/theme/main';
import { RewardCoupon } from '@/components/reward-coupon';
import { RewardStatus } from '@/types/teamRanking';
var TAB_ENUM;
(function (TAB_ENUM) {
    TAB_ENUM[TAB_ENUM["CALL_RECORDS"] = 0] = "CALL_RECORDS";
    TAB_ENUM[TAB_ENUM["FREE_CARD_RECORDS"] = 1] = "FREE_CARD_RECORDS";
})(TAB_ENUM || (TAB_ENUM = {}));
const TAB_CONFIG = [{
        title: '券包奖励',
        type: TAB_ENUM.CALL_RECORDS
    }, {
        title: '现金奖励',
        type: TAB_ENUM.FREE_CARD_RECORDS
    }];
var SCENE_TYPE;
(function (SCENE_TYPE) {
    SCENE_TYPE[SCENE_TYPE["ORDER"] = 1] = "ORDER";
    SCENE_TYPE[SCENE_TYPE["BROWSE"] = 2] = "BROWSE";
    SCENE_TYPE[SCENE_TYPE["CALL"] = 3] = "CALL";
})(SCENE_TYPE || (SCENE_TYPE = {}));
const SCENE_TYPE_MAP = {
    [SCENE_TYPE.ORDER]: '预定酒店',
    [SCENE_TYPE.BROWSE]: '浏览热门酒店',
    [SCENE_TYPE.CALL]: '打Call助力成功'
};
export default function RewardRecords(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const ctx = useMonitorEngineContext();
    const { monitorNavigateToSmart } = useMonitorJumper();
    const { rateHeight } = getFullScreenSize();
    const [showDrawResultModal, setShowDrawResultModal] = useOrderPopup(false, POPUP_ORDER.FREE_CARD);
    const [drawResultData, setDrawResultData] = useState();
    const [showUnlockedFreeCardPopup, setShowUnlockedFreeCardPopup] = useState(false);
    const [showFreeCardMaxAmount, setShowFreeCardMaxAmount] = useState();
    const unlockedFreeCardRewardId = useRef();
    // Tab
    const [tabIndex, setTabIndex] = useState(TAB_ENUM.CALL_RECORDS);
    const { request: requestUseFreeCard } = useRequest(API_PATH.USE_FREE_CARD, {
        showLoading: true,
        loadingText: '兑换中'
    });
    const freeCardInfo = useMemo(() => {
        var _a;
        const rewardId = (_a = props.rewardsData.find(item => { var _a, _b, _c; return item.type === RewardType.FREE_CARD && !lessThan((_a = item.freeOrderCardExtra) === null || _a === void 0 ? void 0 : _a.completeProgress, (_b = item.freeOrderCardExtra) === null || _b === void 0 ? void 0 : _b.needFinishProgress) && !((_c = item.freeOrderCardExtra) === null || _c === void 0 ? void 0 : _c.exchanged); })) === null || _a === void 0 ? void 0 : _a.rewardId;
        return {
            hasUnusedFreeCard: !!rewardId,
            rewardId
        };
    }, [props.rewardsData]);
    useEffect(() => {
        if (freeCardInfo.hasUnusedFreeCard && freeCardInfo.rewardId) {
            // 自动使用
            goUseFreeCard(freeCardInfo.rewardId);
        }
    }, [freeCardInfo]);
    function goUseFreeCard(rewardId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!rewardId) {
                ctx._uiInteractionAPI.toast.show({
                    content: '使用失败，请稍后重试'
                });
                return;
            }
            const res = yield requestUseFreeCard({
                activityId: props.activityId,
                taskId: props.taskId,
                rewardId
            });
            if ((res === null || res === void 0 ? void 0 : res.uni_status_code) === NO_VALID_ORDER_FOR_FREE_CARD) {
                ctx._uiInteractionAPI.toast.show({
                    content: '目前没有符合条件的订单～',
                    duration: 1500
                });
                setTimeout(() => {
                    props.onClose();
                    jumpToOrder();
                }, 1500);
                return;
            }
            const freeOrderCard = res === null || res === void 0 ? void 0 : res.extra;
            if (!(freeOrderCard === null || freeOrderCard === void 0 ? void 0 : freeOrderCard.exchanged)) {
                ctx._uiInteractionAPI.toast.show({
                    title: '未找到符合条件的订单',
                    content: '请下单后再来使用免单卡哦～',
                    icon: 'guanbimian',
                    duration: 1500
                });
                setTimeout(() => {
                    props.onClose();
                    jumpToOrder();
                }, 1500);
                return;
            }
            const validHotelName = !!(freeOrderCard === null || freeOrderCard === void 0 ? void 0 : freeOrderCard.hotelName);
            if (validHotelName && (freeOrderCard === null || freeOrderCard === void 0 ? void 0 : freeOrderCard.exchanged)) {
                setDrawResultData(freeOrderCard);
                setShowDrawResultModal(true);
            }
            else {
                ctx._uiInteractionAPI.toast.show({
                    content: '兑换失败，请稍后重试'
                });
            }
        });
    }
    // 去下单
    function jumpToOrder() {
        const isInWX = isWeixinMiniProgramOrWeixinWebview();
        if (isInWX) {
            if (!props.gotoOrderUrlInWX)
                return;
            const platform = getPlatformType();
            const webviewUrl = platform === PlatformType.mtMinaWebview ?
                // 对美团小程序有特殊逻辑，使用酒小的WebView打开
                isH5URL(props.gotoOrderUrlInWX) ? `/hotel/pages/h5/index?q=${encodeURIComponent(props.gotoOrderUrlInWX)}` : props.gotoOrderUrlInWX : convertH5ToWebviewPath(props.gotoOrderUrlInWX, platform);
            return navigateTo({
                url: webviewUrl,
                _web: {
                    miniProgramNative: true
                }
            });
        }
        else {
            // app、h5跳转
            if (!props.gotoOrderUrlInMt)
                return;
            navigateTo({
                url: props.gotoOrderUrlInMt
            });
        }
    }
    // 渲染免单卡项目
    const renderFreeCardItem = (item, key, isLast) => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (item.cashExtra && item.type === RewardType.CASH) {
            return <View key={key} className="free-card-item" style={{
                marginBottom: isLast ? '0rpx' : '24rpx'
            }}>
          <View className="free-card-content">
            <Text className="free-card-title" numberOfLines={1}>返现奖励</Text>
            <Text className="free-card-subtitle">可在美团余额中查看</Text>
          </View>
          <View className="hotel-reward-right">
            <View className="hotel-reward-amount">
              <Text className="amount-symbol">¥</Text>
              <Text className="amount-value" style={MTfinStyle}>
                {convertCentsToYuan((_a = item.cashExtra) === null || _a === void 0 ? void 0 : _a.obtainAmount, 2).str}
              </Text>
            </View>
            <Text className="hotel-reward-status">
              {item.rewardStatus === RewardStatus.SUCCESS ? '奖励已到账' : '奖励发放中'}
            </Text>
          </View>
        </View>;
        }
        else if ((_b = item.freeOrderCardExtra) === null || _b === void 0 ? void 0 : _b.exchanged) {
            return <View key={key} className="hotel-reward-item" style={{
                marginBottom: isLast ? '0rpx' : '24rpx'
            }}>
          <View className="hotel-reward-left">
            <Text className="hotel-reward-title" numberOfLines={1}>
              {(_c = item.freeOrderCardExtra) === null || _c === void 0 ? void 0 : _c.hotelName}
            </Text>
            <View className="hotel-reward-tag-container">
              <View className="hotel-reward-tag">
                <View style={{
                width: '34rpx',
                height: '34rpx',
                backgroundColor: '#FFC6C1',
                borderRadius: '12rpx',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: '-8rpx',
                position: 'relative',
                zIndex: 2
            }}>
                  <Text className="tag-free-text">免</Text>
                </View>
                <View className="tag-detail">
                  <Text className="tag-detail-text">1房1晚·实付价</Text>
                </View>
              </View>
              <Text className="hotel-reward-subtitle">{props.freeCardDesc}</Text>
            </View>
          </View>
          <View className="hotel-reward-right">
            <View className="hotel-reward-amount">
              <Text className="amount-symbol">¥</Text>
              <Text className="amount-value" style={MTfinStyle}>
                {convertCentsToYuan((_d = item.freeOrderCardExtra) === null || _d === void 0 ? void 0 : _d.obtainAmount, 2).str}
              </Text>
            </View>
            
          </View>
        </View>;
        }
        else {
            const unlocked = lessThan((_e = item.freeOrderCardExtra) === null || _e === void 0 ? void 0 : _e.completeProgress, (_f = item.freeOrderCardExtra) === null || _f === void 0 ? void 0 : _f.needFinishProgress);
            const { rewardAdrUpper } = (_g = item.freeOrderCardExtra) !== null && _g !== void 0 ? _g : {};
            return <View key={key} className="free-card-item" style={{
                marginBottom: isLast ? '0rpx' : '24rpx'
            }}>
          <View className="free-card-content">
            <Text className="free-card-title">{rewardAdrUpper ? `${convertCentsToYuanInteger(rewardAdrUpper)}元` : ''}免单卡</Text>
            <Text className="free-card-subtitle">{props.freeCardDesc}</Text>
          </View>
          <Button className="use-button" onPress={() => {
                if (unlocked) {
                    unlockedFreeCardRewardId.current = item.rewardId;
                    setShowFreeCardMaxAmount(rewardAdrUpper);
                    setShowUnlockedFreeCardPopup(true);
                }
                else {
                    goUseFreeCard(item.rewardId);
                }
            }}>
            <LinearGradient className="use-button" colors={['#FFE74D', '#FFDD00']} start={{
                x: 0,
                y: 0
            }} end={{
                x: 1,
                y: 0
            }}>
              <Text className="use-button-text">{unlocked ? '分享解锁' : '去使用'}</Text>
            </LinearGradient>
          </Button>
        </View>;
        }
    };
    const timestampToDate = (timestamp) => {
        // 检查是否为数字且为有限值
        if (typeof timestamp !== 'number' || !isFinite(timestamp)) {
            return '';
        }
        // 检查时间戳是否为合理范围（大于0，且不超过最大安全整数）
        if (timestamp < 0 || timestamp > Number.MAX_SAFE_INTEGER) {
            return '';
        }
        const date = new Date(timestamp);
        const Y = date.getFullYear();
        const M = String(date.getMonth() + 1).padStart(2, '0');
        const D = String(date.getDate()).padStart(2, '0');
        return `${Y}/${M}/${D}`;
    };
    const freeCardRewards = props.rewardsData.filter(item => [RewardType.FREE_CARD, RewardType.CASH].includes(item.type));
    const callRecords = (_c = (_b = (_a = props.callRecordsData) === null || _a === void 0 ? void 0 : _a.groupInviteRecordModels) === null || _b === void 0 ? void 0 : _b[0].inviteRecordModels) !== null && _c !== void 0 ? _c : [];
    const rewardCouponInfos = props.rewardsData.filter(item => [RewardType.COUPON].includes(item.type) && item.couponExtra) || [];
    const showRewardCoupons = rewardCouponInfos.map(item => {
        const { uuid, rewardJumpUrl } = item;
        const { couponType, couponName, desc, useRule, reduceAmount, requireAmount } = item.couponExtra;
        return {
            applyId: uuid,
            type: couponType,
            name: couponName,
            url: rewardJumpUrl,
            money: reduceAmount,
            desc,
            useRule: `满${requireAmount}可用`,
            requireAmount
        };
    });
    // 渲染打Call记录项目
    const renderCallRecordItem = (item, key, isLast) => {
        return <View key={key} className="call-record-item" style={{
            marginBottom: isLast ? '0rpx' : '16rpx'
        }} onClick={() => {
            var _a;
            (_a = props.loadMoreCallRecords) === null || _a === void 0 ? void 0 : _a.call(props);
        }}>
        <View className="call-record-left">
          <Text className="call-record-title">{SCENE_TYPE_MAP[item.inviteScene] || '打Call成功'}</Text>
          <Text className="call-record-time">
            {item.inviteTime ? timestampToDate(item.inviteTime) : ''} {`为${item.inviteGroupName}贡献`}
          </Text>
        </View>
        <View className="call-record-right">
          <Text className="call-record-amount">+{item.inviteValue || 0}</Text>
          <Text className="call-record-desc">{`${props.callValueDesc || 'Call值'}`}奖励</Text>
        </View>
      </View>;
    };
    const onRewardCouponClick = (url, applyId) => {
        url && monitorNavigateToSmart(url);
    };
    return <TopView>
      <ModalBaseContainer type="slide" visible={props.rewardRecordsVisible} contentStyle={{
        height: 1312 > rateHeight * 0.8 ? `${rateHeight * 0.8}rpx` : '1312rpx'
    }} showMask onMaskPress={props.onClose}>
        <LImage source={{
        uri: RewardRecordsTheme.BackgroundImage
    }} style={{
        width: '750rpx',
        height: '1312rpx'
    }} borderRadius={0}>
          
          <View className="reward-records-header-t">
            <LImage source={{
        uri: RewardRecordsTheme.TitleImage
    }} style={{
        width: '750rpx',
        height: '108rpx'
    }}/>
            <LImage source={{
        uri: RewardRecordsTheme.CloseButton
    }} style={{
        width: '36rpx',
        height: '36rpx',
        position: 'absolute',
        right: '34rpx',
        top: '10rpx'
    }} onPress={props.onClose}/>
          </View>

          
          <View className="reward-records-tabs-container">
            {TAB_CONFIG.map((item, index) => {
        return <View key={index} className={`reward-records-tabs-item ${tabIndex === item.type ? 'reward-records-tabs-item-active' : ''}`} onClick={() => {
            setTabIndex(item.type);
        }}>
                  <Text className={`reward-records-tabs-text `}>{item.title}</Text>
                </View>;
    })}
          </View>
				<RewardCoupon x-if={tabIndex === TAB_ENUM.CALL_RECORDS} couponInfos={showRewardCoupons} onClick={onRewardCouponClick} style={{
        marginBottom: '15rpx'
    }}/>
          
          {tabIndex === TAB_ENUM.CALL_RECORDS && ((_f = (_e = (_d = props.callRecordsData) === null || _d === void 0 ? void 0 : _d.groupInviteRecordModels) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.cycleStartTime) && ((_j = (_h = (_g = props.callRecordsData) === null || _g === void 0 ? void 0 : _g.groupInviteRecordModels) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.cycleEndTime) && <View className="activity-time-container">
                <Text className="activity-time-text">
                  当前活动周期时间：
                  {`${timestampToDate((_m = (_l = (_k = props.callRecordsData) === null || _k === void 0 ? void 0 : _k.groupInviteRecordModels) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.cycleStartTime)} - ${timestampToDate((_q = (_p = (_o = props.callRecordsData) === null || _o === void 0 ? void 0 : _o.groupInviteRecordModels) === null || _p === void 0 ? void 0 : _p[0]) === null || _q === void 0 ? void 0 : _q.cycleEndTime)}`}
                </Text>
              </View>}

          
          <View className="reward-records-content" style={{
        height: 1312 > rateHeight * 0.8 ? `${rateHeight * 0.8 - 223}rpx` : '1089rpx'
    }}>
            {props.rewardsStatus === RequestStatus.LOADING ? <View className="loading-container">
                <LoadingView showIcon showContent bgColorType="dark" level="medium" theme={{
        medium: {
            spacing: 15,
            textType: 'body4'
        }
    }} animate content={'加载中'}/>
              </View> : <ScrollView>
                
                {tabIndex === TAB_ENUM.CALL_RECORDS ? (callRecords === null || callRecords === void 0 ? void 0 : callRecords.length) > 0 ? <>
                      {callRecords === null || callRecords === void 0 ? void 0 : callRecords.map((item, itemIndex) => {
        return renderCallRecordItem(item, itemIndex, itemIndex === (callRecords === null || callRecords === void 0 ? void 0 : callRecords.length) - 1);
    })}
                      <Sensor onAppear={props.loadMoreCallRecords}>
                        <View style={{
        height: '20rpx'
    }}></View>
                      </Sensor>
                    </> : <View style={{
        marginTop: '180rpx'
    }}>
                      <ActivityInvalid type="empty" text="暂无打call记录，快去参与活动吧～" color="#555555" style={{
        marginTop: '100rpx'
    }} icon={RewardRecordsTheme.EmptyIcon} textStyle={{
        marginTop: '-40rpx'
    }}/>
                    </View> : (freeCardRewards === null || freeCardRewards === void 0 ? void 0 : freeCardRewards.length) > 0 ? freeCardRewards === null || freeCardRewards === void 0 ? void 0 : freeCardRewards.map((item, itemIndex) => {
        return renderFreeCardItem(item, itemIndex, itemIndex === (freeCardRewards === null || freeCardRewards === void 0 ? void 0 : freeCardRewards.length) - 1);
    }) : <View style={{
        marginTop: '180rpx'
    }}>
                    <ActivityInvalid type="empty" text="暂无奖励记录，快去参与活动吧～" color="#555555" style={{
        marginTop: '100rpx'
    }} icon={RewardRecordsTheme.EmptyIcon} textStyle={{
        marginTop: '-40rpx'
    }}/>
                  </View>}
                <View style={{
        height: '100rpx'
    }}></View>
              </ScrollView>}
          </View>
        </LImage>
      </ModalBaseContainer>

      <FreeCardDrawResultPopup key={Date.now()} visible={showDrawResultModal} freeOrderCardExtra={drawResultData} onShareFreeCard={props.onShareFreeCard} onClose={() => {
        setShowDrawResultModal(false);
        props.onFetchRewardsData();
    }} freeCardDesc={props.freeCardDesc || '离店后5个工作日返至【我的-余额】'}/>

      <UnlockedFreeCardPopup freeCardMaxAmount={showFreeCardMaxAmount} visible={showUnlockedFreeCardPopup} onClose={() => {
        setShowFreeCardMaxAmount(undefined);
        setShowUnlockedFreeCardPopup(false);
    }} onInviteUnlock={() => {
        if (unlockedFreeCardRewardId.current) {
            props.onInviteUnlock(unlockedFreeCardRewardId.current);
        }
        else {
            ctx._uiInteractionAPI.toast.show({
                content: '邀请出错了，请稍后重试'
            });
        }
    }}/>
    </TopView>;
}
